var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-pikaday',_vm._b({staticClass:"form-control my-1",attrs:{"options":_vm.pikadayOptions,"name":_vm.name},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}},'vue-pikaday',_vm.properties,false))
}
var staticRenderFns = []

export { render, staticRenderFns }